var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrimary = function SvgPrimary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 59 24",
    "aria-hidden": "true",
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    className: "service-logo service--nhs",
    role: "img",
    "aria-label": "NHS logo"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "service-logo-main",
    d: "M59,24V0H0v24H59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "service-logo-text",
    d: "M5.77,2.32h6.41l3.94,13.4h0.05l2.7-13.4h4.85l-4.07,19.32h-6.39 L9.24,8.27H9.18L6.51,21.63H1.66L5.77,2.32L5.77,2.32z M25.62,2.32h5.15l-1.51,7.39h6.08l1.52-7.39H42l-3.99,19.32h-5.15l1.71-8.27 h-6.09l-1.71,8.27h-5.15L25.62,2.32L25.62,2.32z M55.55,6.69c-0.99-0.47-2.34-0.88-4.24-0.88c-2.04,0-3.69,0.3-3.69,1.85 c0,2.74,7.46,1.72,7.46,7.58c0,5.34-4.93,6.72-9.39,6.72c-1.98,0-4.27-0.47-5.95-1l1.21-3.93c1.02,0.67,3.06,1.11,4.73,1.11 c1.6,0,4.1-0.31,4.1-2.3c0-3.1-7.46-1.94-7.46-7.39c0-4.98,4.35-6.48,8.57-6.48c2.37,0,4.6,0.25,5.89,0.86L55.55,6.69L55.55,6.69z"
  }))));
};
export default SvgPrimary;